import React from "react";
import "../home.css";
import "../styles/home-journey.css";
import "../styles/know-us.css";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { WhatsAppWidget } from "../components/WhatsAppWidget";
import { KnowUsPageContent } from "../components/know-us/KnowUsPageContent";

export const KnowUsPage = () => (
    <div className="container journey-page know-us-page">
        <Header />
        <div className="content know-us-page__content">
            <div className="home-container know-us-page__main">
                <KnowUsPageContent />
            </div>

            <div className="wrapper know-us-page__footer-wrap">
                <Footer />
            </div>
        </div>
        <WhatsAppWidget />
    </div>
);
